// extracted by mini-css-extract-plugin
module.exports = {"receiverInstructions":"ReceiverInstructions_receiverInstructions__ChqNy","input":"ReceiverInstructions_input__3LzY6","cardCloseX":"ReceiverInstructions_cardCloseX__1xQch"};